import Education from './education';

export default {
  namespaced: true,
  modules: {
    Education
  },
};
